import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { Api } from "../api";
import { Quiz } from "../../models/quiz.model";
import { UserQuiz } from '../../models/user-quiz.model';

@Injectable()
export class QuizProvider extends Api {

  constructor(public http: HttpClient) {
    super(http);
  }

  getByID(id: number): Observable<Quiz> {
    return this.http
      .get<Quiz>(`${this.url}/quizzes/${id}`)
      .map(response => {
        return new Quiz(response);
      })
      .catch(this.handleError)
  }

  getAll(): Observable<Quiz[]> {
    return this.http
      .get<Quiz[]>(`${this.url}/quizzes`)
      .map(response => {
        return response.map((quiz) => new Quiz(quiz));
      })
      .catch(this.handleError);
  }

  finish(id: number): Observable<UserQuiz> {
    return this.http
      .get<UserQuiz>(`${this.url}/quizzes/finish/${id}`)
      .map(response => {
        return new UserQuiz(response);
      })
      .catch(this.handleError)
  }

}



// WEBPACK FOOTER //
// ./src/providers/quiz/quiz.ts